import { lazy } from 'react'

const BotelSocialFooter = lazy(() => import('../BotelSocialFooter'))

export default BotelSocialFooter;